// extracted by mini-css-extract-plugin
export default {"container":"frank_container__kgjW1","content":"frank_content__8HbRt","button":"frank_button__dsspj","resultsContainer":"frank_resultsContainer__BPrt2"};